module.exports = __webpack_public_path__ + "img/invalid-temperature.8b2cc3d8.png";